import {AbstractControl, ValidatorFn} from "@angular/forms";

export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value) {
      return null;
    }
    const phoneRegexp = /^(\+?\d{3}[-\s.]?\d{3}[-\s.]?\d{4,6}|\+?\(\d{3}\)\s?\d{3}[-\s.]?\d{4,6})$/;

    const invalid = !phoneRegexp.test(control.value);

    if (invalid) {
      return {phone: invalid};
    }

    return null;
  };
}
